import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./hooks/useAuth";
import Theme from "./theme";
import App from "./App";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
    <BrowserRouter>
        <AuthProvider>
            <Theme>
                <App />
            </Theme>
        </AuthProvider>
    </BrowserRouter>
);
